export default __webpack_public_path__ + "static/media/anchor.27766340.png";